<template>
  <div class="dine-in-table table-responsive">
    <div class="table-right">
      <table class="table">
        <tbody>
          <tr>
            <td class="pb-0">{{ _T('Item Total') }}</td>
            <td class="pb-0">
              <h4>
                {{ order.currency + ' ' + Num.price(order.sub_total) }}
              </h4>
            </td>
          </tr>
          <tr>
            <td>{{ _T('Delivery Surcharge') }}</td>
            <td>
              <h4>
                {{ order.currency + ' ' + Num.price(order.delivery_surcharge) }}
              </h4>
            </td>
          </tr>
          <tr v-if="order.tip_amount">
            <td>{{ _T('Driver Tip') }}</td>
            <td>
              <h4>
                {{ order.currency + ' ' + Num.price(order.tip_amount) }}
              </h4>
            </td>
          </tr>
          <!-- <tr>
            <td>{{ _T('Cashback Balance') }}</td>
            <td class="cashback-color">
              <h4>-{{ order.currency + ' ' +Num.price( order.balance_due * 0.05) }}</h4>
            </td>
          </tr> -->
          <tr
            v-for="(orderSurcharge, index) in order.order_surcharges"
            :key="index"
          >
            <td>{{ _T_DB(orderSurcharge, 'name') }}</td>
            <td class="cashback-color">
              <h4>
                {{ order.currency + ' ' + Num.price(orderSurcharge.price) }}
              </h4>
            </td>
          </tr>
          <tr>
            <td>{{ _T('Bill Amount') }}</td>
            <td>
              <h4>{{ order.currency + ' ' + Num.price(totalAmount) }}</h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrderPriceDetails',
  props: {
    order: {
      type: [Object, Array],
      default () {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(['_T', '_T_DB']),
    totalAmount () {
      if (this.order) {
        return parseFloat(this.order.tip_amount) + parseFloat(this.order.balance_due)
      }
      return 0
    }
  },
}
</script>

<style lang="scss" scoped>
.dine-in-table {
  @media (max-width: 575px) {
    overflow-x: unset !important;
  }
  .table-right {
    border-top: $px1 dashed $light-border;

    table {
      width: auto;
      margin-left: auto;
      @media (max-width: 575px) {
        width: 100% !important;
        margin-left: unset !important;
      }
      tr {
        td {
          min-width: $px165;
          border-top: none;
          font-weight: normal;
          font-size: $px20;
          line-height: $px24;
          @media (max-width: 575px) {
            font-size: $px15;
            padding-left: 0 !important;
          }
          h4 {
            font-weight: normal;
            font-size: $px18;
            text-align: right;
            @media (max-width: 575px) {
              font-size: $px12;
            }
          }
        }

        &:last-child {
          border-top: $px1 solid $light-border;

          td {
            padding-bottom: 0;
            font-weight: 600;
            h4 {
              font-weight: bold;
              font-size: $px20;
              @media (max-width: 575px) {
                font-size: $px13;
              }
            }
          }
        }
      }
    }
  }
}
</style>
